import { Pipe, PipeTransform } from "@angular/core";

@Pipe({
    name: 'isSelected'
})
export class IsSelectedItemPipe implements PipeTransform {
    transform(item: any, selectedItems: any[], key: string): boolean {
        return selectedItems.some(si => key.split(',').every(k => si[k.trim()] == item[k.trim()]));
    }
}